import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { GhostArticles, useModal } from '@minerva-analytics/pantheon';
import { ThemeProvider } from 'styled-components';
import { useLocation } from 'react-router-dom';
import DonateModal from '../../components/DonateModal';
import { GHOST_API } from '../../ghost';
import { SITE_URL } from '../../constants';

import Scribble from '../../assets/scribble.png';

import { WHITE, BLACK, CANDY_RED, PEARL } from '../../theme';

import {
  theme,
  ArticlesContainer,
  Header,
  HeaderText,
  ScribbleImage,
  HeaderWrapper,
} from './Articles.styles';

const colors = {
  background: PEARL,
  featuredbg: BLACK,
  featuredblurb: WHITE,
  title: WHITE,
  published: BLACK,
  author: BLACK,
  readtime: CANDY_RED,
  viewmore: BLACK,
};

const fonts = {
  title: 'Lato',
  body: 'Lato',
};

const Articles = () => {
  const { hash } = useLocation();
  const { isShowing, toggleModal } = useModal();

  useEffect(() => {
    if (hash === `#donate` || hash === `#thanks`) {
      toggleModal();
    }
  }, [hash]);
  return (
    <>
      <DonateModal
        isShowing={isShowing}
        hide={toggleModal}
        backdropClosesModal
      />
      <Helmet>
        <title>The History of Everyday Objects Blog | Back Then History</title>
        <meta
          name="og:title"
          property="og:title"
          content="The History of Everyday Objects Blog | Back Then History"
        />
        <meta
          name="og:description"
          property="og:description"
          content="Have you ever wondered where everyday objects come from? Do you love history trivia? You’ll love Back Then History. Check out our blog today!"
        />
        <meta
          name="description"
          property="description"
          content="Have you ever wondered where everyday objects come from? Do you love history trivia? You’ll love Back Then History. Check out our blog today!"
        />
      </Helmet>
      <Header>
        <HeaderWrapper>
          <ScribbleImage src={Scribble} alt="Scribble graphic" />
          <HeaderText>The Fascinating History of Everyday Objects</HeaderText>
        </HeaderWrapper>
      </Header>
      <ArticlesContainer>
        <ThemeProvider theme={theme}>
          <GhostArticles
            domain={SITE_URL}
            ghostApi={GHOST_API}
            colors={colors}
            fonts={fonts}
          />
        </ThemeProvider>
      </ArticlesContainer>
    </>
  );
};

export default Articles;
